import _ from 'lodash';
window._ = _;

try {
    window.bootstrap = require('bootstrap');
} catch (e) {}

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
